<div fxLayout="column" fxLayoutAlign="center center" style="margin-top:10px;" fxFlex="100">

  <div fxLayout="row" fxLayoutAlign="start" fxFlex="100">
    <div class="pageTitle">Διαχείριση επιπέδων δραστηριοτήτων</div>
  </div>


  <div fxLayout="column" style="margin-top:50px;" fxFlex="100">
    <div fxLayout="row" fxFlex="100" style="width:400px;">
      <mat-form-field fxFlex="95">
        <label>
          <input matInput [(ngModel)]="newLevel" type="text" placeholder="Περιγραφή επιπέδου"/>
        </label>
      </mat-form-field>

      <button mat-icon-button fxFlex="5" matTooltip="Προσθήκη" (click)="insertLevel()"><mat-icon>add</mat-icon></button>

    </div>
  </div>

  <div fxLayout="row" style="margin-top:20px; width:400px;">

    <div class="questionsContainer" fxLayout="column"  style="width:100%;">
      <ng-container *ngIf="loadingLevels; else ShowQuestions">
        <app-loading></app-loading>
      </ng-container>

      <ng-template #ShowQuestions>
        <div fxLayout="column" fxFlex>
          <div *ngFor="let level of levels" fxLayout="row">

            <!--          <div fxFlex="5" fxLayoutAlign="center center">-->
            <!--            {{activity.id}}-->
            <!--          </div>-->

            <div fxFlex="90" fxLayoutAlign="start center">
              {{level.description}}
            </div>

            <div fxFlex="10" fxLayoutAlign="center center" fxLayout="column">
              <div fxLayout="row">
                <!--            <button mat-icon-button matTooltip="Ενημέρωση">-->
                <!--              <mat-icon>edit</mat-icon>-->
                <!--            </button>-->
                <button mat-icon-button matTooltip="Διαγραφή" (click)="confirmDeletion(level)">
                  <mat-icon>delete</mat-icon>
                </button>
              </div>

            </div>

          </div>
        </div>
      </ng-template>
    </div>

  </div>

</div>
